/*
 *---------------------------------------------------
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *---------------------------------------------------
 */
import React from "react";
import { Route, Redirect } from "react-router-dom";
import { DASHBOARD } from "../constants/routes";
import { Box, Grid } from "@material-ui/core";
import { ContentSection, Header, SidebarSection } from "../components";
import { useCSRValue } from "../context";
import { Menu } from "../containers";

export interface AuthProtectRouteProps {
  user: any;
  [extraProps: string]: any;
}

const AuthProtectedRoute = ({
  user,
  children,
  ...rest
}: AuthProtectRouteProps) => {
  const { csr } = useCSRValue();

  return (
    <Route
      {...rest}
      render={({ location }) => {
        if (user.userLoggedIn) {
          return (
            <Box>
              <Box>
                <Header shopAs={false} username={csr && csr.userLoggedIn} />
              </Box>

              <Grid
                container
                alignItems="stretch"
                className="min-content-height">
                <SidebarSection>
                  <Menu />
                </SidebarSection>
                <ContentSection>{children}</ContentSection>
              </Grid>
            </Box>
          );
        }

        if (!user || !user.userLoggedIn) {
          return (
            <Redirect
              to={{
                pathname: DASHBOARD,
                state: { from: location },
              }}
            />
          );
        }

        return null;
      }}
    />
  );
};

export default AuthProtectedRoute;
